import { useEffect } from 'react';
import { Main } from '../../components/Main/Main';
import { CreateSubscriptionModal } from '../../components/subscriptions/CreateSubscriptionModal';
import { Subscription } from '../../components/subscriptions/Subscription';
import { useImmer } from '../../hooks/useImmer';
import { useTranslation } from '../../i18n/i18n';
import { useApi } from '../../state/api';
import { Res } from '../../state/api-resources';
import { ApiList } from '../../types';
import { Routing } from '../Routes';
import { ErrorPage } from './ErrorPage';
import { LoaderPage } from './LoaderPage';
import './SubscriptionsPage.css';

export const Subscriptions = (): JSX.Element => {
	const [subscriptions, setSubscriptions] = useImmer<ApiList[] | undefined>([]);
	const { data, error, mutate } = useApi(Res.lists, {});
	const t = useTranslation().subscriptions;

	useEffect(() => {
		return setSubscriptions(data);
	}, [data]);

	const refresh = () => mutate(subscriptions, true);

	if (error) return <ErrorPage message={error.message} />;
	if (!subscriptions) return <LoaderPage />;

	return (
		<Main>
			<h1 className="big">{t.subscriptionTitle}</h1>
			<p className="lead">{t.schedule.informationText}</p>
			<div className="subscriptions-page">
				{subscriptions.map((list) => (
					<Subscription key={list.id} list={list} updateSubscriptions={refresh} />
				))}
				<CreateSubscriptionModal
					onCreate={() => {
						mutate(subscriptions, true);
					}}
					subscriptionsCount={subscriptions.length}
				/>
			</div>
			<div className="disclaimer">
				<p>{t.schedule.dispensationText}</p>
			</div>
		</Main>
	);
};

export const subscriptionsRouting: Routing = {
	path(urls) {
		return urls.subscriptions;
	},
	component: Subscriptions,
	requiresAuth: true,
};
